<template>
  <div class="tw-flex tw-flex-col tw-gap-1">
    <label
      v-if="label"
      :class="[
        'tw-text-xs tw-font-poppins',
        'tw-text-[#1F2229]',
      ]"
    >
      {{ label }}
    </label>
    <input
      v-bind="$attrs"
      :class="[
        'tw-w-full tw-px-3 tw-py-2',
        'tw-bg-[#EEEFF2] tw-text-[#1F2229]',
        'tw-rounded-md tw-border-none',
        'tw-font-poppins',
      ]"
      @input="handleUpdate"
    >
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'SidebarInput',
  components: { /* Subcomponents */ },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: null,
    },
  },
  data() {
    return {

    };
  },
  computed: { /*
      Creates a new property
      Updates when any dependant property changes */
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    handleUpdate(event) {
      const value = event.target.value;

      if (this.$attrs.type === 'number' && value) {
        this.$emit('input', parseFloat(value));
        return;
      }
      this.$emit('input', value);
    },
  },
};
</script>


  <style scoped>

  </style>
